<template>
  <div class="header">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <h1>Дистанционное обучение и онлайн-курсы</h1>
          <p>
            Проводим обучение и тестирование персонала удаленно. Если вы хотите пройти обучение или организовать
            обучение ваших специалистов, оставьте заявку
          </p>
          <b-field class="nav_search" type="is-info">
            <b-input placeholder="Введите текст"></b-input>
          </b-field>
          <button @click="$emit('open')">Оставить заявку</button>
        </div>
      </div>
    </div>
    <!-- <div class="swiper-button swiper-button-prev"><i class="icon-button-arrow"></i></div>
         <div class="swiper-button swiper-button-next"><i class="icon-button-arrow"></i></div> -->
  </div>
</template>

<script>
export default {
  name: 'Header'
}
</script>
